import { render, staticRenderFns } from "./WxpayPayConfig.vue?vue&type=template&id=54ee1da9&scoped=true"
import script from "./WxpayPayConfig.vue?vue&type=script&lang=js"
export * from "./WxpayPayConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ee1da9",
  null
  
)

export default component.exports